module.exports = __webpack_public_path__ + "img/qr_aboutus.da0451a5.jpg";